import { useEffect } from 'react';
import { useLocation } from 'react-router';
import './HeaderMobileMenu.scss';

type HeaderMobileMenuProps = {
  isSession?: boolean;
  onClickLogout(): Promise<void>;
  onClickGoToPath(path: string): void;
};

const HeaderMobileMenu = ({ isSession, onClickGoToPath, onClickLogout }: HeaderMobileMenuProps) => {
  const location = useLocation();
  const { pathname } = location;

  let loginUrl;

  if (process.env.NODE_ENV === 'development') {
    loginUrl = 'http://localhost:3000';
    // redirectUrl = 'http://localhost:3001' + location.pathname;
  } else if (process.env.NODE_ENV === 'production') {
    loginUrl = 'https://my.vrware.us';
    // redirectUrl = 'https://school.vrware.us' + location.pathname;
  }

  useEffect(() => {
    function onClickToggle() {
      document.querySelector('.menu-trigger')?.classList.toggle('icon-active');
      document.querySelector('.links')?.classList.toggle('toggle');
      document.querySelector('.cotton')?.classList.toggle('cotton-toggle');

      if (pathname === '/') {
        document.querySelector('.headroom-wrapper')?.classList.toggle('headroom-transparent');
      }
    }

    document.getElementById('menu-trigger')?.addEventListener('click', onClickToggle);
    document.getElementById('cotton')?.addEventListener('click', onClickToggle);

    return () => {
      document.getElementById('menu-trigger')?.removeEventListener('click', onClickToggle);
      document.getElementById('cotton')?.removeEventListener('click', onClickToggle);
    };
  }, [pathname]);

  return (
    <div className='HeaderMobileMenu'>
      <div className='wrapper'>
        <div className='menu-trigger' id='menu-trigger'>
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className='links'>
          <ul>
            {/* 원래 커뮤니티임 */}
            <li onClick={() => onClickGoToPath('/download')}>다운로드</li>
            {/* <li onClick={() => onClickGoToPath('/pricing')}>가격 및 결제</li> */}
            <li>
              <a href='https://my.vrware.us/cs' target='_sub'>
                고객센터
              </a>
            </li>
            {!isSession ? (
              <div>
                <li>
                  <a href={`${loginUrl}/join`}>회원가입</a>
                  {/* <a href={`${loginUrl}/join?redirectUrl=${redirectUrl}`}>회원가입</a> */}
                </li>
                <li>
                  {/* <a href={`${loginUrl}/login?redirectUrl=${redirectUrl}`}>로그인</a> */}
                  <a href={`${loginUrl}/login`}>로그인</a>
                </li>
              </div>
            ) : (
              <div>
                <li onClick={() => onClickGoToPath('/mypage')}>마이페이지</li>
                <li onClick={onClickLogout}>로그아웃</li>
              </div>
            )}
          </ul>
          <div className='cotton' id='cotton' />
        </div>
      </div>
    </div>
  );
};

export default HeaderMobileMenu;
